import { render } from "./CookieModal.vue?vue&type=template&id=5846c5c4&scoped=true"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"

import "./CookieModal.vue?vue&type=style&index=0&id=5846c5c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5846c5c4"]])

export default __exports__